import { useState } from "react";
import PropTypes from "prop-types";
import env from "react-dotenv";
import Text from "../mui/Text";
import { useStylesForText } from "shared/styles/makeStyles";
import Slack from "shared/components/utils/icons/Slack";
import Email from "shared/components/utils/icons/Email";
import {
    Container,
    Content,
    Column,
    PictureColumn,
    EmployeePicture,
    Contact,
    ExternalLink,
    EmailLink,
    CopyContainer,
    Tip,
} from "./Card.styles";

const Card = ({ label, photo, name, title, department, slack, email }) => {
    const [copy, setCopy] = useState("Copy");
    const copyToClipboard = () => {
        if (navigator?.clipboard) {
            navigator.clipboard.writeText(email);
            setCopy("Copied");
        }
    };
    const classesText = useStylesForText();

    return (
        <>
            {name && (
                <Container>
                    <Text variant="xsmallLight" className={classesText.gray2}>
                        {label}
                    </Text>
                    <Content>
                        <PictureColumn xs={1}>
                            <EmployeePicture url={photo} />
                        </PictureColumn>
                        <Column>
                            <Text variant="xsmall">{name}</Text>
                            <Text
                                variant="xsmallLight"
                                className={classesText.gray2}
                            >
                                {title}, {department}
                            </Text>
                            <Contact>
                                {slack && (
                                    <CopyContainer>
                                        <ExternalLink
                                            href={`slack://user?team=${env.BESTWORK_REACT_SLACK_TEAM_ID}&id=U0AGBSQTY`}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <Text variant="xsmall">
                                                {slack}
                                            </Text>
                                            <Tip>
                                                <Slack />
                                                <Text
                                                    variant="xsmallLight"
                                                    className={
                                                        classesText.gray2
                                                    }
                                                >
                                                    Message
                                                </Text>
                                            </Tip>
                                        </ExternalLink>
                                    </CopyContainer>
                                )}
                                {email && (
                                    <CopyContainer>
                                        <EmailLink
                                            noUnderline
                                            noHover
                                            onClick={() => {
                                                copyToClipboard();
                                            }}
                                        >
                                            <Text variant="xsmall">
                                                {email}
                                            </Text>
                                            <Tip>
                                                <Email />
                                                <Text
                                                    variant="xsmallLight"
                                                    className={
                                                        classesText.gray2
                                                    }
                                                >
                                                    {copy}
                                                </Text>
                                            </Tip>
                                        </EmailLink>
                                    </CopyContainer>
                                )}
                            </Contact>
                        </Column>
                    </Content>
                </Container>
            )}
        </>
    );
};

Card.defaultProps = {
    label: "",
    photo: "",
    name: "",
    title: "",
    department: "",
    slack: "",
    email: "",
};

Card.propTypes = {
    label: PropTypes.string,
    photo: PropTypes.string,
    name: PropTypes.string,
    title: PropTypes.string,
    department: PropTypes.string,
    slack: PropTypes.string,
    email: PropTypes.string,
};

export default Card;
